// extracted by mini-css-extract-plugin
module.exports = {"container":"Footer_container__st7Zp","img":"Footer_img__3qdcC","from":"Footer_from__2T69H","name":"Footer_name__nnSvP","to":"Footer_to__ul7lh"};